import React from 'react';
import { Link } from 'react-router-dom';

const RegistrationForm = () => {
  return ( 
    <div id="register" className="relative min-h-screen flex items-center justify-center bg-gray-900 overflow-hidden">
      {/* Video Background */}
      <video 
        autoPlay 
        loop 
        muted 
        className="absolute z-0 w-auto min-w-full min-h-full max-w-none object-cover opacity-30"
      >
        <source src="/videos/tech-background.mp4" type="video/mp4" />
      </video>

      {/* Registration Form Container */}
      <div className="relative z-10 w-full max-w-md px-8 py-10 bg-white rounded-2xl shadow-2xl">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
            INFINITY TECH AFRICA
          </h1>
          <p className="text-gray-500 mt-2">Join our growing community</p>
        </div>

        {/* Form */}
        <form className="space-y-6">
          {/* Organization Name */}
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Organization name
            </label>
            <input
              type="text"
              placeholder="e.g. Meliora"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
            />
          </div>

          {/* Organization Category */}
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Organization category
            </label>
            <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all">
              <option value="">Select category</option>
              <option value="tech">Technology</option>
              <option value="finance">Finance</option>
              <option value="education">Education</option>
              <option value="healthcare">Healthcare</option>
              <option value="other">Other</option>
            </select>
          </div>

          {/* Full Name */}
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Full name
            </label>
            <input
              type="text"
              placeholder="User Full Name"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Email address
            </label>
            <input
              type="email"
              placeholder="User Email"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
            />
          </div>

          {/* Mobile Number */}
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Mobile number
            </label>
            <input
              type="tel"
              placeholder="e.g 254700000000"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
            />
          </div>

          {/* Referral Source */}
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Where did you hear about us?
            </label>
            <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all">
              <option value="">Select an option</option>
              <option value="social">Social Media</option>
              <option value="friend">Friend/Colleague</option>
              <option value="search">Search Engine</option>
              <option value="event">Event/Conference</option>
              <option value="other">Other</option>
            </select>
          </div>

          {/* Terms Checkbox */}
          <div className="flex items-center">
            <input
              id="terms"
              type="checkbox"
              className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="terms" className="ml-2 block text-gray-700">
              I agree to the <a href="#" className="text-blue-600 hover:underline">Terms and Conditions</a>
            </label>
          </div>

          {/* Divider */}
          <div className="border-t border-gray-200"></div>

          {/* Register Button */}
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-blue-600 to-green-600 hover:from-blue-700 hover:to-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300"
          >
            REGISTER
          </button>
        </form>

        {/* Login Link */}
        <div className="mt-6 text-center">
          <p className="text-gray-600">
            Already have an account?{' '}
            <Link to="/login" className="text-blue-600 font-medium hover:underline">
              Login
            </Link>
          </p>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center text-gray-500 text-sm">
          <p>2016 - {new Date().getFullYear()} © All rights reserved. Powered by <span className="font-bold text-blue-600">Infinity Tech Africa</span></p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationForm;